module.exports = __webpack_public_path__ + "static/media/26UNRWA20.d59d2fd8.jpg";